import PropTypes from 'prop-types';

import { connect, CustomContainer } from "../../atoms/DependencyHelper";

import {
  numberFormat,
  imagePrefix,
} from "utils/helperServices";
import labels from "../../../config/labels";


import styles from "./DealDurationAndPrice.module.scss";
// import { propTypes } from 'react-bootstrap/esm/Image';

const DealDurationAndPrice = (props) => {

  const renderPriceDurationCard = (contract, index) => {
    const hasSaving = !!(
      Number(contract.old_monthly_recurring) > 0
      && Number(contract.old_monthly_recurring) > Number(contract.price)
    );
    const price = numberFormat(Math.round(contract.price));
    const oldPrice = numberFormat(Math.round(contract.old_monthly_recurring));
    const savings = numberFormat(Math.round(props.dealData?.save_monthly_recurring))

    return (
      <CustomContainer key={index}>
        <CustomContainer
          className={`${styles["contract-box"]}
            ${ contract.id === props.dealData?.sku ? styles["contract-box--active"] : ""} 
            col-xs-6 col-md-3`}
          onClick={() => props.handleContract(contract.id)}
        >
          <CustomContainer>
            <p className={styles["contract-box--duration"]}>
              x {contract.duration} {labels.lbl_months.toLowerCase()}
            </p>

            { hasSaving
              ? (
                <>
                  <p className={styles["contract-box--discount"]}>
                    {`R${price} ${labels.lbl_pm}`}
                  </p>
                  <p className={styles["contract-box--old-price"]}>
                    {`R${oldPrice} ${labels.lbl_pm}`}
                  </p>
                </>
              )
              : (
                <p className={styles["contract-box--price"]}>
                  {`R${price} ${labels.lbl_pm}`}
                </p>
              )
            }
          </CustomContainer>

          { props.dealData?.sku === contract.id
            ? (
              <img
                className={styles["radio-selector"]}
                src={`${imagePrefix}/assets/images/pillvector.svg`}
              />
            )
            : <span className={`${styles["radio-selector"]} ${styles["selection-placeholder"]}`} />
          }
        </CustomContainer>

        { hasSaving &&
          <p className={styles["contract-box--savings"]}>{ `SAVE R${savings} PM!` }</p>
        }
      </CustomContainer>
    )
  }

  return (
    <div className={`${styles["container-group"]}`}>
      <CustomContainer className={`${styles["contracts-container"]} row`}>
        { props.contractsDurations.map(renderPriceDurationCard) }
      </CustomContainer>
    </div>
  );
}

DealDurationAndPrice.propTypes = {
  handleContract: PropTypes.func,

  // Redux
  contractsDurations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    duration: PropTypes.string,
    price: PropTypes.number,
  })),
  dealData: PropTypes.object,
};

DealDurationAndPrice.defaultProps = {
  dealData: null,
  handleContract: () => {},
}

const mapStateToProps = (state) => ({
  dealData: state.dealDetails.selectedDealDetails,
  contractsDurations: state.dealDetails.contractsDurations
});

export default connect(mapStateToProps, {})(DealDurationAndPrice);
